<template>
    <div id="active">
        <ul>
            <li v-for="(activeItem,index) in activeItems" :key="index">
                <a :href="activeItem.url" @click="addPageView(activeItem.code)">
                    <img :src="'images/' + activeItem.code +'.jpg'" :title="activeItem.name" v-lazy="'images/' + activeItem.code +'.jpg'">
                    <div class="img_remind clearfix"><span></span>
                        <p><img src="../assets/images/heart_03.png"><span>{{activeItem.pageView?activeItem.pageView:0}}人喜欢</span></p>
                    </div>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'active',
        data() {
            return {
                activeItems: []
            }
        },
        mounted() {
            this.addActiveList()
        },
        methods: {
            addActiveList() {
                let _this = this;

                this.$http.post('/campaign/listOnShelf.ctrl', {
                        headers: {
                            'content-type': 'application/json'
                        }
                    })
                    .then(function (res) {
                        _this.activeItems = res.data.object
                    })
                    .catch(function (err) {
                        console.log(err)
                    })
            },
            addPageView(code) {
                let _this = this;

                this.$http.post('/campaign/addPageView.ctrl', {
                        "code":code
                    }, {
                        headers: {
                            'content-type': 'application/json'
                        },

                    })
                    .then(function (res) {

                    })
                    .catch(function (err) {
                        console.log(err)
                    })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Active.vue?e7c3a5f0